import { Center, Grid, GridItem, Stack } from "@chakra-ui/react";
import { Form, Options, Show, Stat } from "components";
import { Enums } from "config";
import { useState } from "react";
import { useReport } from "hooks";
import { Moment } from "config";
import { Mask } from "config";
import WithdrawMonthlyGrowthChart from "./monthly_growth_chart";

export default function Withdraws(){

    const [ period, setPeriod ] = useState(Enums.Period.MONTH)
    const periods = Object.keys(Enums.Period).map(item => ({ children: Enums.Period.data(Enums.Period[item]).label, value: Enums.Period[item] }))

    const withdraws_total = useReport('withdraws_total', period)
    const withdraws_approved = useReport('withdraws_approved_total', period)
    const withdraws_waiting = useReport('withdraws_waiting_total', period)
    const withdraws_done = useReport('withdraws_done_total', period)
    const withdraws_total_average = useReport('withdraws_total_average', period)

    return(
    <>
    <Center mb={12}>
        <Options 
            onChange={setPeriod}
            defaultSelected={period}
            options={periods}
            size="xs"
        />
    </Center>
    
    <WithdrawMonthlyGrowthChart period={Enums.Period.YEAR} />

    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
        <GridItem>
            <Stat.Item
                loading={withdraws_total.isFetching}
                label="Total solicitado"
                value={`R$ ${Mask.price(withdraws_total.data?.data ?? 0)}`}
                helper={`${Moment(withdraws_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(withdraws_total.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
            />
        </GridItem>

        <GridItem>
            <Stat.Item
                label="Em Análise"
                loading={withdraws_waiting.isFetching}
                color="orange.500"
                value={`R$ ${Mask.price(withdraws_waiting.data?.data ?? 0)}`}
                helper={`${Moment(withdraws_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(withdraws_total.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
            />
        </GridItem>

        <GridItem>
            <Stat.Item
                label="Aprovados"
                loading={withdraws_approved.isFetching}
                color="blue.500"
                value={`R$ ${Mask.price(withdraws_approved.data?.data ?? 0)}`}
                helper={`${Moment(withdraws_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(withdraws_total.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
            />
        </GridItem>

        <GridItem>
            <Stat.Item
                label="Depositados"
                loading={withdraws_done.isFetching}
                color="teal.500"
                value={`R$ ${Mask.price(withdraws_done.data?.data ?? 0)}`}
                helper={`${Moment(withdraws_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(withdraws_total.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
            />
        </GridItem>

        <GridItem>
            <Stat.Item
                label="Média de pedidos de saque"
                loading={withdraws_total_average.isFetching}
                value={`R$ ${Mask.price(withdraws_total_average.data?.data ?? 0)}`}
                helper={`${Moment(withdraws_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(withdraws_total.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
            />
        </GridItem>
    </Grid>
    </>
    )
}